export const getDurationScrollByPixel = (scrollDistanceInPx: number) => {
  let duration = Math.round(Math.abs(scrollDistanceInPx / 3))
  duration = duration < 500 ? 500 : duration > 2000 ? 0 : duration

  return duration
}
